
import { HealthDashboard } from '@/components/HealthDashboard';

const Dashboard = () => {
  return <HealthDashboard />;
};

export default Dashboard;
